import { render } from "./GroupCallView.vue?vue&type=template&id=c51600ca&scoped=true"
import script from "./GroupCallView.vue?vue&type=script&lang=js"
export * from "./GroupCallView.vue?vue&type=script&lang=js"

import "./GroupCallView.vue?vue&type=style&index=0&id=c51600ca&lang=scss&scoped=true"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c51600ca"]])

export default __exports__